var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{class:_vm.containerClasses},_vm._l((_vm.filteredControls),function(controlId){return _c('ControlView',{key:controlId,attrs:{"control":_vm.controls[controlId],"parent-id":_vm.row.uniqueId,"value-container":_vm.valueContainer,"validation-errors":_vm.validationErrors,"read-only":_vm.readOnly,"language":_vm.language}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }